// Local storage keys and the rules around them.
//
// Some of what we keep in local storage belongs to the sign-in session (the auth
// token, the cart) and some of it belongs to the browser itself: the cookie
// consent the visitor already gave, and the delivery location they already
// picked. Logging out must only wipe the first group - clearing the second makes
// the cookie banner and the location popup come back at the next sign-in, which
// is what this module exists to prevent.

export const LOCATION_KEY = "location";
export const COOKIE_CONSENT_KEY = "cookieModal";

// answers the visitor gave once and should not be asked for again
const BROWSER_PREFERENCE_KEYS = [LOCATION_KEY, COOKIE_CONSENT_KEY];

// reads the stored delivery location, tolerating a corrupt/hand-edited value
export const readStoredLocation = () => {
    const raw = window.localStorage.getItem(LOCATION_KEY);

    if (!raw) return null;

    try {
        return JSON.parse(raw);
    } catch (error) {
        window.localStorage.removeItem(LOCATION_KEY);
        return null;
    }
};

export const writeStoredLocation = (location) => {
    if (location) {
        window.localStorage.setItem(LOCATION_KEY, JSON.stringify(location));
    } else {
        window.localStorage.removeItem(LOCATION_KEY);
    }
};

export const hasAcceptedCookies = () => !!window.localStorage.getItem(COOKIE_CONSENT_KEY);

export const rememberCookieConsent = () => window.localStorage.setItem(COOKIE_CONSENT_KEY, "true");

// wipes everything the session owns while keeping the browser's own answers
export const clearSessionStorage = () => {
    const preserved = BROWSER_PREFERENCE_KEYS.map((key) => [key, window.localStorage.getItem(key)]);

    window.localStorage.clear();

    preserved.forEach(([key, value]) => {
        if (value !== null) window.localStorage.setItem(key, value);
    });
};
